import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Analytics from "@/pages/Analytics";
import FileEditor from "@/pages/FileEditor";
import Depository from "@/pages/Depository";
import Admin from "@/pages/Admin";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#5C5C54] font-mono-eo text-[12px] uppercase tracking-widest">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Analytics /></Protected>} />
      <Route path="/files/my" element={<Protected><Dashboard scope="my" /></Protected>} />
      <Route path="/files/shared" element={<Protected><Dashboard scope="shared" /></Protected>} />
      <Route path="/files/sent" element={<Protected><Dashboard scope="sent" /></Protected>} />
      <Route path="/files/closed" element={<Protected><Dashboard scope="approved" /></Protected>} />
      <Route path="/files/approved" element={<Navigate to="/files/closed" replace />} />
      <Route path="/files/:id" element={<Protected><FileEditor /></Protected>} />
      <Route path="/depository" element={<Protected><Depository /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" richColors closeButton toastOptions={{ style: { borderRadius: 2, border: "1px solid #DCD9D0" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
